/**
 * The Supabase client, and the one rule about it.
 *
 * Fortunaut is online-with-cache, not local-first, and that is the deliberate
 * divergence from Cleanify. Cleanify can afford a client-authoritative ledger
 * because gold is family-internal; a Fortunaut balance is money a parent owes,
 * so a modified client that could write ledger rows could mint dollars. Every
 * value-creating write therefore goes through the server — RLS for scoping,
 * and issuance (refills, allowance, boost) through server-side jobs the client
 * can only ask to run, never author.
 *
 * The anon key is public on purpose. RLS is the protection, not the key.
 */

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Missing config is a first-run state, not a crash.
 *
 * The domain layer and every pure screen work without a backend, and the tests
 * never touch one. Throwing at import time would take the whole app down for a
 * missing `.env` on a machine that only wanted to run the calculator.
 */
export const isConfigured = Boolean(url && anonKey);

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        // Adults only. Child profiles live under the guardian's account and
        // switch by PIN — there is no child session to persist.
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
